<template>
  <div class="chart_wrap">
    <div class="title" v-if="title !== ''">{{title}}</div>
    <canvas class="myChart" :id="id"  :height="height"></canvas>
  </div>
</template>

<script>
import F2 from "@antv/f2/lib/index-all"
export default {
  props:{
    data:{
      type:Array,
      default:function() {
        return []
      }
    },
    title:{
      type:String,
      default:''
    },
    id:{
      type:String,
      default:'chart'
    },
    height:{
      type:String,
      default:'260'
    }
  },
  mounted() {
    // 创建 Chart 对象
    this.chart = new F2.Chart({
      id: this.id,
      pixelRatio: window.devicePixelRatio, // 指定分辨率
    });
  }
}
</script>

<style lang="less" scoped>
.myChart{
  width: 100% !important;
}
.title{
  display: flex;
  justify-content: center;
  margin-bottom: 0.1rem;
  font-size:16px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:22px;
}
</style>